import {
  ActionIcon,
  Button,
  Group,
  Modal,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import IconEdit from "@tabler/icons-react/dist/esm/icons/IconEdit.mjs";
import { useMutation } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { changeDescription } from "../../../../services/flag";
import { useDispatch } from "react-redux";
import { updateResolutionStatusHistoryRow } from "../../../../redux/features/flagDetails/flagDetailsSlice";
import classes from "./resolutionHistoryTable.module.scss";

const EditDescriptionModal = ({ rowText, id }) => {
  const dispatch = useDispatch();
  const [opened, { open, close }] = useDisclosure(false);
  const [description, setDescription] = useState(rowText);

  useEffect(() => {
    if (!opened) {
      setDescription("");
    } else {
      setDescription(rowText);
    }
  }, [opened, rowText]);

  const { isPending, mutateAsync } = useMutation({
    mutationKey: ["resolution-history-edit-description", description],
    mutationFn: () => changeDescription({ id, description }),
  });
  const handleUpdate = async () => {
    const data = await mutateAsync();
    dispatch(updateResolutionStatusHistoryRow(data));
    close();
  };

  return (
    <>
      <Group justify="space-between">
        <Tooltip label={rowText} disabled={!rowText} multiline maw={400}>
          <Text className={classes.description} size="sm">
            {rowText}
          </Text>
        </Tooltip>
        <ActionIcon onClick={open} bg="transparent">
          <IconEdit color="gray" />
        </ActionIcon>
      </Group>

      <Modal opened={opened} onClose={close} title="Edit Description" centered>
        <TextInput
          value={description}
          mt="md"
          mb="md"
          onChange={({ target: { value } }) => setDescription(value)}
        />
        <Group justify="space-between">
          <Button color="red" onClick={close}>
            Cancel
          </Button>
          <Button loading={isPending} onClick={handleUpdate} variant="outline">
            Confirm
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default EditDescriptionModal;
